export type Language = 'pt' | 'en' | 'es'

export const translations = {
  pt: {
    // Login Page
    login: {
      title: 'Entrar',
      welcome: 'Bem-vindo ao Eximtech',
      subtitle: 'Gestão inteligente de fretes internacionais',
      email: 'Email',
      emailPlaceholder: 'Seu e-mail',
      password: 'Senha',
      passwordPlaceholder: 'Sua senha',
      loginButton: 'Entrar',
      demoButton: 'Demo',
      forgotPassword: 'Esqueceu a senha?',
      magicLink: 'Enviar link mágico',
      loading: 'Aguarde...',
      demoMessage: 'Modo demonstração em breve',
      demoContact: 'Entre em contato para agendar uma demonstração personalizada',
    },
    // Transport modes
    transport: {
      land: 'Terra',
      sea: 'Mar',
      air: 'Ar',
    },
    // Dashboard
    dashboard: {
      title: 'Dashboard',
      welcome: 'Bem-vindo',
      quotes: 'Cotações',
      proposals: 'Propostas',
      orders: 'Pedidos',
      settings: 'Configurações',
      logout: 'Sair',
    },
    // Quotes
    quotes: {
      title: 'Cotações',
      newQuote: 'Nova Cotação',
      listTitle: 'Minhas Cotações',
      status: 'Status',
      origin: 'Origem',
      destination: 'Destino',
      modality: 'Modalidade',
      type: 'Tipo',
      created: 'Criado em',
      actions: 'Ações',
    },
    // Common
    common: {
      save: 'Salvar',
      cancel: 'Cancelar',
      edit: 'Editar',
      delete: 'Excluir',
      view: 'Visualizar',
      back: 'Voltar',
      next: 'Próximo',
      previous: 'Anterior',
      search: 'Buscar',
      filter: 'Filtrar',
      export: 'Exportar',
      import: 'Importar',
      add: 'Adicionar',
      remove: 'Remover',
      confirm: 'Confirmar',
      yes: 'Sim',
      no: 'Não',
    },
  },
  en: {
    // Login Page
    login: {
      title: 'Login',
      welcome: 'Welcome to Eximtech',
      subtitle: 'Intelligent international freight management',
      email: 'Email',
      emailPlaceholder: 'Your email',
      password: 'Password',
      passwordPlaceholder: 'Your password',
      loginButton: 'Login',
      demoButton: 'Demo',
      forgotPassword: 'Forgot password?',
      magicLink: 'Send magic link',
      loading: 'Wait...',
      demoMessage: 'Demo mode coming soon',
      demoContact: 'Contact us to schedule a personalized demo',
    },
    // Transport modes
    transport: {
      land: 'Land',
      sea: 'Sea',
      air: 'Air',
    },
    // Dashboard
    dashboard: {
      title: 'Dashboard',
      welcome: 'Welcome',
      quotes: 'Quotes',
      proposals: 'Proposals',
      orders: 'Orders',
      settings: 'Settings',
      logout: 'Logout',
    },
    // Quotes
    quotes: {
      title: 'Quotes',
      newQuote: 'New Quote',
      listTitle: 'My Quotes',
      status: 'Status',
      origin: 'Origin',
      destination: 'Destination',
      modality: 'Modality',
      type: 'Type',
      created: 'Created at',
      actions: 'Actions',
    },
    // Common
    common: {
      save: 'Save',
      cancel: 'Cancel',
      edit: 'Edit',
      delete: 'Delete',
      view: 'View',
      back: 'Back',
      next: 'Next',
      previous: 'Previous',
      search: 'Search',
      filter: 'Filter',
      export: 'Export',
      import: 'Import',
      add: 'Add',
      remove: 'Remove',
      confirm: 'Confirm',
      yes: 'Yes',
      no: 'No',
    },
  },
  es: {
    // Login Page
    login: {
      title: 'Iniciar sesión',
      welcome: 'Bienvenido a Eximtech',
      subtitle: 'Gestión inteligente de fletes internacionales',
      email: 'Correo electrónico',
      emailPlaceholder: 'Tu correo',
      password: 'Contraseña',
      passwordPlaceholder: 'Tu contraseña',
      loginButton: 'Iniciar',
      demoButton: 'Demo',
      forgotPassword: '¿Olvidó la contraseña?',
      magicLink: 'Enviar enlace mágico',
      loading: 'Espere...',
      demoMessage: 'Modo demostración próximamente',
      demoContact: 'Contáctenos para programar una demostración personalizada',
    },
    // Transport modes
    transport: {
      land: 'Tierra',
      sea: 'Mar',
      air: 'Aire',
    },
    // Dashboard
    dashboard: {
      title: 'Panel',
      welcome: 'Bienvenido',
      quotes: 'Cotizaciones',
      proposals: 'Propuestas',
      orders: 'Pedidos',
      settings: 'Configuración',
      logout: 'Salir',
    },
    // Quotes
    quotes: {
      title: 'Cotizaciones',
      newQuote: 'Nueva Cotización',
      listTitle: 'Mis Cotizaciones',
      status: 'Estado',
      origin: 'Origen',
      destination: 'Destino',
      modality: 'Modalidad',
      type: 'Tipo',
      created: 'Creado en',
      actions: 'Acciones',
    },
    // Common
    common: {
      save: 'Guardar',
      cancel: 'Cancelar',
      edit: 'Editar',
      delete: 'Eliminar',
      view: 'Ver',
      back: 'Volver',
      next: 'Siguiente',
      previous: 'Anterior',
      search: 'Buscar',
      filter: 'Filtrar',
      export: 'Exportar',
      import: 'Importar',
      add: 'Añadir',
      remove: 'Quitar',
      confirm: 'Confirmar',
      yes: 'Sí',
      no: 'No',
    },
  },
}

export type TranslationKey = keyof typeof translations.pt
